<template>
  <div>
    <br />
    <br />
    <div class="txt-pred">
      <h2 style="color: #002856;">Texterkennung</h2>
      <br />
      <b-card-group deck>
        <b-card img-src="./../assets/text_pred.png" img-alt="Card image" img-top>
          <b-card-text
            style="color: black;"
          >Auch in bei Texterkennung haben die Neuronalen Netze die Nase vorn. Im Gegensatz zu den Bildern werden hier aber Textdaten mit verschiedenen Informationen als Trainingmenge verwendet. In der Trainingsmenge waren Produkttext sowie auch wetiere Produktinformatinoen wie Farbe, Grösse, Preis, etc. enthalten.</b-card-text>
        </b-card>
        <b-card img-alt="Card image">
          <b-card-text
            style="color: black;"
          >Unten im Textfeld können Sie beliebig Sätzte oder nur Worte eingeben. Nachdem Sie auf "Senden" gedrückt haben, erhalten Sie wie bei der Bilderkennung fünf Kategorien der Wahrscheinlichkeit nach absteigend geordnet angezeigt.</b-card-text>
          <br />
          <textarea
            rows="4"
            cols="66"
            name="text"
            v-model="text"
            class="from-control"
            placeholder="Hier Text einfügen für die Vorhersage.."
            autocfocus
            required
          ></textarea>
          <br />
          <br />
          <button
            id="sub"
            type="submit"
            class="btn btn-outline-success btn-lg"
            @click="submitText()"
          >Senden</button>
          <br />
          <br />
          <template v-if="!showResultBars && buttonClicked">
            <b-spinner large type="grow" variant="success" label="Loading..." />
          </template>
          <template v-if="showResultBars">
            <PercentageBars :probabilities="response" />
          </template>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ShowPreds from "./ShowPreds";
import PercentageBars from "./PercentageBars";

export default {
  name: "TextPred",
  components: {
    ShowPreds,
    PercentageBars
  },
  data() {
    return {
      showResultBars: false,
      text: "",
      response: {},
      buttonClicked: false,
      apiBase: process.env.VUE_APP_ROOT_API,
      token: process.env.VUE_APP_API_TOKEN
    };
  },
  methods: {
    /*
        Submits the file to the server
      */
    submitText() {
      if (this.text != "") {
        let formData = new FormData();
        this.buttonClicked = true;
        formData.append("text", this.text);
        console.log(this.text);
        console.log(formData);

        axios
          .post(this.apiBase + "/predict/text/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: this.token
            }
          })
          .then(response => {
            if (response.status == 200) {
              console.log("SUCCESS!!");
              console.log(response);
              this.response = response.data;
              this.showResultBars = true;
            }
          })
          .catch(error => {
            console.log(error);
            this.buttonClicked = false;
            this.showResultBars = false;
            alert("An error has occured");
          });
      } else {
        alert("Text field is empty");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-form {
  color: black;
  margin: 10px 10px 0 3px;
  padding: 50px 100px 100px 220px;
}
p {
  padding: 50px 0px 0px 0px;
}
#sub {
  color: #002856;
  border-color: #002856;
}
textarea {
  min-height: 5em;
  max-height: 50vh;
  width: 100%;
}
</style>
